var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ProjectMap from '../shared/ProjectMap.vue';
import Cta from '../shared/Cta.vue';
import Loader from '../shared/Loader.vue';
import ProjectInfo from './ProjectInfo.vue';
const service = namespace('Service');
let ProjectBrowser = class ProjectBrowser extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.data = [];
        this.index = 0;
        this.homeProject = [];
        this.activeProject = {};
    }
    created() {
        this.getProjectBrowserData({ showOnHomepage: null, siteId: window.cibbic.siteId });
    }
    onMapClicked(id) {
        this.gotoProject(id);
    }
    gotoProject(id) {
        for (let i = 0; i < this.homeProject.length; i++) {
            if (this.homeProject[i].id === id) {
                this.activeProject = this.homeProject[i];
                break;
            }
        }
    }
    previous() {
        const index = this.homeProject.findIndex((p) => { return p.id === this.activeProject.id; });
        if (index === 0) {
            this.activeProject = this.homeProject[this.homeProject.length - 1];
        }
        else {
            this.activeProject = this.homeProject[index - 1];
        }
    }
    next() {
        const index = this.homeProject.findIndex((p) => { return p.id === this.activeProject.id; });
        if (index === this.homeProject.length - 1) {
            this.activeProject = this.homeProject[0];
        }
        else {
            this.activeProject = this.homeProject[index + 1];
        }
    }
    nl2br(str) {
        if (str)
            return str.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
    }
    onDataChanged() {
        this.data = this.projects;
        this.homeProject = this.data.filter((p) => { return p.showOnHomepage; });
        this.activeProject = this.homeProject[this.index];
        window.cibbic.lazyLoadInstance.update();
        this.loading = false;
    }
    get sectors() {
        return this.activeProject && this.activeProject.sector ? this.activeProject.sector.map(function (sector) {
            return sector.title;
        }).join(", ") : "";
    }
};
__decorate([
    Prop({ type: Object })
], ProjectBrowser.prototype, "labels", void 0);
__decorate([
    Prop()
], ProjectBrowser.prototype, "approvedProjects", void 0);
__decorate([
    Prop()
], ProjectBrowser.prototype, "investments", void 0);
__decorate([
    Prop()
], ProjectBrowser.prototype, "cost", void 0);
__decorate([
    service.State
], ProjectBrowser.prototype, "projects", void 0);
__decorate([
    service.Action
], ProjectBrowser.prototype, "getProjectBrowserData", void 0);
__decorate([
    Watch('projects')
], ProjectBrowser.prototype, "onDataChanged", null);
ProjectBrowser = __decorate([
    Component({
        components: {
            ProjectMap,
            ProjectInfo,
            Cta,
            Loader
        }
    })
], ProjectBrowser);
export default ProjectBrowser;
